export default __webpack_public_path__ + "static/media/102g.584c27ea.svg";